import { AppState } from "../../../../../redux/reducers";

// stores
import * as ContractCommissionAgentConceptStore from '../../../../../redux/middleware/ContractCommissionAgentConceptMiddleware';
import * as ContractStore from '../../../../../redux/middleware/ContractMiddleware';
import * as ContractCommissionAgentStore from '../../../../../redux/middleware/ContractCommissionAgentMiddleware';
import * as ContractConceptStore from '../../../../../redux/middleware/ContractConceptMiddleware';

// models
import { ContractCommissionAgentConcept } from "../../../../../models/Entities/Contracts/ContractCommissionAgentConcept";
import { ErrorType } from "../../../../../models/HttpError";
import { Contract } from "../../../../../models/Entities/Contracts/Contract";
import { ContractCommissionAgent } from "../../../../../models/Entities/Contracts/ContractCommissionAgent";
import { ContractConcept } from "../../../../../models/Entities/Contracts/ContractConcept";



interface IProps {
  CommissionAgentConcept: ContractCommissionAgentConcept;
  disabled?: boolean;
  onClick?: (conceptId: number) => void;
};

interface ConnectedProps {
    isLoading: boolean;
    LoadedSuccessfully: boolean | undefined;
    FailOnLoading: boolean;
    ErrorOnLoading: ErrorType | undefined;
    isSaving: boolean;
    SavingSuccessfully: boolean | undefined;
    ContractId: number | undefined;
    CommissionAgentId: number | undefined;
    Contract: Contract;
    CommissionConcept: ContractCommissionAgentConcept;
    Agent: ContractCommissionAgent | undefined;
    Concept: ContractConcept | undefined;
};

interface MedicalServicesDispatchProps {
    DeleteContractCommissionAgentConcept: typeof ContractCommissionAgentConceptStore.actionCreators.DeleteContractCommissionAgentConcept;
    GetContractById: typeof ContractStore.actionCreators.GetContractById;
    GetContractCommissionAgentById: typeof ContractCommissionAgentStore.actionCreators.GetContractCommissionAgentById;
    GetContractConceptById: typeof ContractConceptStore.actionCreators.GetContractConceptById;
};


export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    
    const CurrentContractId = ownProps.CommissionAgentConcept.contractId;
    
    const CurrentContract: Contract | undefined = CurrentContractId ? state.Contract?.list?.find((contract: Contract) => contract.id === CurrentContractId) : undefined;

    const CurrentCommissionAgent: ContractCommissionAgent | undefined = CurrentContract?.commissionAgents?.find((commissionAgent: ContractCommissionAgent) => commissionAgent.id === ownProps.CommissionAgentConcept.commissionAgentId);
    
    const CurrentCommissionAgentConcept = CurrentCommissionAgent?.Concepts?.find((commissionAgentConcept: ContractCommissionAgentConcept) => commissionAgentConcept.id === ownProps.CommissionAgentConcept.id);
    
    const CurrentConcept = CurrentContract?.concepts?.find((concept: ContractConcept) => concept.id === ownProps.CommissionAgentConcept.conceptId);
    
    return {
        isLoading: state.ContractCommissionAgentConcept?.isLoadingAll,
        LoadedSuccessfully: state.ContractCommissionAgentConcept?.successLoadingAll,
        FailOnLoading: state.ContractCommissionAgentConcept?.failOnLoadingAll,
        ErrorOnLoading: state.ContractCommissionAgentConcept?.error,
        isSaving: state.ContractCommissionAgentConcept?.isAddingNewOne || state.ContractCommissionAgentConcept?.isUpdatingOne,
        SavingSuccessfully: state.ContractCommissionAgentConcept?.successAddingNewOne || state.ContractCommissionAgentConcept?.successUpdatingOne,
        ContractId: CurrentContractId,
        CommissionAgentId: ownProps.CommissionAgentConcept.commissionAgentId,
        Contract: CurrentContract,
        CommissionConcept: CurrentCommissionAgentConcept,
        Concept: CurrentConcept,
        Agent: CurrentCommissionAgent,
    };
}

export const mapDispatchToProps = ({
    ...ContractCommissionAgentConceptStore.actionCreators,
    ...ContractStore.actionCreators,
    ...ContractCommissionAgentStore.actionCreators,
    ...ContractConceptStore.actionCreators,
});